import BackendAPI from '../../../../../api/BackendAPI';

class EmailVerifyInputModel extends BackendAPI {

    constructor() {
        super();
        this.serverPath = window.config.coreApiUrl;
    }

    ////////////////
    ////// API /////
    ////////////////

    verifyEmail(email) {
        return this.request('GET', `${this.serverPath}/towerdataemailverify/${email}`);
    }
}

export default EmailVerifyInputModel;
